import { render, staticRenderFns } from "./CPOTableComparison.vue?vue&type=template&id=4e2f308c&scoped=true&"
import script from "./CPOTableComparison.vue?vue&type=script&lang=js&"
export * from "./CPOTableComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f308c",
  null
  
)

export default component.exports